export default {
  loading: (state:any) => state.app.loading,
  messageVisiable: (state:any) => state.app.messageVisiable,
  message: (state:any) => state.app.message,
  messageType: (state:any) => state.app.messageType
}